import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../utility/helper";
import $ from "jquery";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt";
import "datatables.net-buttons-dt";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";

const ContactPage = () => {
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true
  });
  const [contacts, setContacts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);

  const [formData, setFormData] = useState({
    type: "",
    name: "",
    designation: "",
    image: null
  });

  useEffect(() => {
    fetchContacts();
  }, []);

  useEffect(() => {
    if (!showForm && contacts.length > 0) {
      setTimeout(() => {
        if ($.fn.DataTable.isDataTable("#contactTable")) {
          $("#contactTable").DataTable().destroy();
        }

        $("#contactTable").DataTable({
          dom: "Bfrtip",
          buttons: ["copy", "csv", "excel", "print"]
        });
      }, 100);
    }
  }, [contacts, showForm]);

  const fetchContacts = async () => {

    if ($.fn.DataTable.isDataTable("#contactTable")) {
      $("#contactTable").DataTable().destroy();
    }

    const res = await axios.get(`${baseurl}/admin/contacts`);

    setContacts(res.data);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFormData((prev) => ({
      ...prev,
      image: file
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {

    const form = new FormData();
    form.append("type", formData.type);
    form.append("name", formData.name);
    form.append("designation", formData.designation);

    if (formData.image) {
      form.append("image", formData.image);
    }

    if (editId) {

      await axios.put(
        `${baseurl}/admin/update-contact/${editId}`,
        form,
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      );
      Toast.fire({
        icon: "success",
        title: "Contact updated successfully"
      });

    } else {

      await axios.post(
        `${baseurl}/admin/add-contact`,
        form,
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      );

      Toast.fire({
        icon: "success",
        title: "Contact added successfully"
      });

    }
    // Destroy DataTable
    if ($.fn.DataTable.isDataTable("#contactTable")) {
      $("#contactTable").DataTable().destroy();
    }

    // Fetch new data
    await fetchContacts();

    // Close form after data loads
    resetForm();

  } catch (err) {
    Toast.fire({
      icon: "error",
      title: "Something went wrong"
    });
    console.error(err);
  }
};

  const handleEdit = (item) => {

    // destroy datatable before hiding table
    if ($.fn.DataTable.isDataTable("#contactTable")) {
      $("#contactTable").DataTable().destroy();
    }

    setEditId(item.id);

    setFormData({
      type: item.contact_type,
      name: item.contact_name,
      designation: item.designation,
      image: item.contact_image ?? null,
    });

    setShowForm(true);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Contact?",
      text: "This action cannot be undone",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      confirmButtonColor: "#d33"
    });

    if (!result.isConfirmed) return;

    try {

      await axios.delete(`${baseurl}/admin/delete-contact/${id}`);

      // Destroy DataTable before updating data
      if ($.fn.DataTable.isDataTable("#contactTable")) {
        $("#contactTable").DataTable().destroy();
      }

      Toast.fire({
        icon: "success",
        title: "Contact deleted successfully",
      });

      await fetchContacts();

    } catch (err) {

      Toast.fire({
        icon: "error",
        title: "Delete failed",
      });

    }
  };
  const resetForm = () => {
    setShowForm(false);
    setEditId(null);

    setFormData({
      type: "",
      name: "",
      designation: "",
      image: null
    });
  };

  return (
    <div className="content container-fluid">
      <div className="container mt-4">
        <div class="profile-section">
          <h3>Contacts Manage</h3>

          {!showForm && (
            <>
              <button
                className="btn btn-primary mb-3"
                style={{float:'right'}}
                onClick={() => {

                  if ($.fn.DataTable.isDataTable("#contactTable")) {
                    $("#contactTable").DataTable().destroy();
                  }

                  setShowForm(true);
                }}
              >
                Add Contact
              </button>

              <table
                id="contactTable"
                className="table table-striped table-bordered"
              >
                <thead>
                  <tr>
                    <th>Image</th>
                    <th>Type</th>
                    <th>Name</th>
                    <th>Designation</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {contacts.map((item) => (
                    <tr key={item.id}>
                      <td>
                      {item.contact_image ? (
                        <img
                          src={`data:image/jpeg;base64,${item.contact_image}`}
                          width="50"
                          alt=""
                        />
                      ) : (
                        <img
                          src="/no-image.png"
                          width="50"
                          alt="No Image"
                        />
                      )}
                    </td>

                      <td>{item.contact_type}</td>
                      <td>{item.contact_name}</td>
                      <td>{item.designation}</td>

                      <td>
                        <button
                          className="btn btn-warning btn-sm"
                          onClick={() => handleEdit(item)}
                        >
                          <i className="bi bi-pencil-square"></i>
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDelete(item.id)}
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}

          {showForm && (
            <div className="card">
              <div className="card-header">
                {editId ? "Edit Contact" : "Add Contact"}
              </div>

              <div className="card-body">

                <form onSubmit={handleSubmit}>

                  <div className="mb-3">
                    <label>Contact Type</label>
                    <input
                      type="text"
                      className="form-control"
                      name="type"
                      value={formData.type}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label>Contact Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label>Designation</label>
                    <input
                      type="text"
                      className="form-control"
                      name="designation"
                      value={formData.designation}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label>Contact Image</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={handleImage}
                    />
                  </div>

                  <button className="btn btn-success me-2" type="submit">
                    {editId ? "Update" : "Submit"}
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={resetForm}
                  >
                    Cancel
                  </button>

                </form>

              </div>
            </div>
          )}

      
        </div>
      </div>
    </div>
  );
};

export default ContactPage;